<template>
  <div>
    <vs-row>
      <vs-col class="lg:w-1/2 p-base bg-primary">
        <div>
          <div class="items-center" style="position: relative">
            <vs-avatar
              v-if="selectedUserData.userData.profilePictureUrl"
              class="profile-picture"
              size="120px"
              :src="
                constants.s3Bucket +
                '/editor/profile-pictures/' +
                selectedUserData.userData.profilePictureUrl
              "
            />
            <vs-avatar
              v-else
              class="profile-picture"
              size="120px"
              :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                selectedUserData.userData.firstName || 'boringAvatar',
                selectedUserData.userData.lastName || 'boringAvatar'
              )}`"
            />
          </div>
          <div class="items-center">
            <div class="mb-base">
              <div class="name text-white">
                {{ selectedUserData.userData.firstName | title }}
                {{ selectedUserData.userData.lastName | title }}
              </div>
              <div v-if="userData.email" class="text-white mb-3 lowercase">
                {{ selectedUserData.userData.email | title }}
              </div>
              <div v-if="userData.roleTitle" class="role-title my-4 text-white">
                {{
                  selectedUserData.roleTitle.label || selectedUserData.roleTitle
                }}
              </div>
              <vs-row class="items-center" style="justify-content: center">
                <div
                  v-if="
                    selectedUserData.userData &&
                    selectedUserData.userData.linkedinProfile
                  "
                  class="flex mr-3 items-center"
                  style="justify-content: center"
                >
                  <vs-tooltip class="cursor-pointer" text="LinkedIn">
                    <vs-button
                      radius
                      color="white"
                      text-color="grey"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-linkedin"
                      :href="selectedUserData.userData.linkedinProfile"
                      target="_blank"
                    ></vs-button>
                  </vs-tooltip>
                </div>
                <div
                  v-if="
                    selectedUserData.userData &&
                    selectedUserData.userData.facebookProfile
                  "
                  class="flex mr-3 items-center"
                  style="justify-content: center"
                >
                  <vs-tooltip class="cursor-pointer" text="Facebook">
                    <vs-button
                      radius
                      color="white"
                      text-color="grey"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-facebook"
                      :href="selectedUserData.userData.facebookProfile"
                      target="_blank"
                    ></vs-button>
                  </vs-tooltip>
                </div>
                <div
                  v-if="
                    selectedUserData.userData &&
                    selectedUserData.userData.twitterProfile
                  "
                  class="flex mr-3 items-center"
                  style="justify-content: center"
                >
                  <vs-button
                    radius
                    color="white"
                    text-color="grey"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-twitter"
                    :href="selectedUserData.userData.twitterProfile"
                    target="_blank"
                  ></vs-button>
                </div>
                <div
                  v-if="
                    selectedUserData.userData &&
                    selectedUserData.userData.personalWebsite
                  "
                  class="flex mr-3 items-center"
                  style="justify-content: center"
                >
                  <vs-button
                    radius
                    color="white"
                    text-color="grey"
                    type="filled"
                    icon="public"
                    :href="selectedUserData.userData.personalWebsite"
                    target="_blank"
                  ></vs-button>
                </div>
                <div
                  v-if="
                    selectedUserData.userData &&
                    selectedUserData.userData.contactNumber
                  "
                  class="flex mr-3 items-center"
                  style="justify-content: center"
                >
                  <vs-button
                    radius
                    color="white"
                    text-color="grey"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-phone"
                    :href="`https://wa.me/${selectedUserData.userData.contactNumber}`"
                    target="_blank"
                  ></vs-button>
                </div>
                <div
                  v-if="
                    selectedUserData.userData && selectedUserData.userData.email
                  "
                  class="flex mr-3 items-center"
                  style="justify-content: center"
                >
                  <vx-tooltip
                    :text="selectedUserData.userData.email"
                    position="bottom"
                  >
                    <a
                      :href="`mailto:${selectedUserData.userData.email}`"
                      target="_blank"
                    >
                      <vs-button
                        radius
                        color="white"
                        text-color="grey"
                        type="filled"
                        icon="mail"
                      ></vs-button>
                    </a>
                  </vx-tooltip>
                </div>
                <div
                  v-if="
                    selectedUserData.userData && selectedUserData.userData.slug
                  "
                  class="flex items-center"
                  style="justify-content: center"
                >
                  <vs-tooltip class="cursor-pointer" text="View Full Profile">
                    <vs-button
                      radius
                      color="white"
                      text-color="grey"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-link"
                      :href="`${constants.url}/${selectedUserData.userData.slug}/${selectedUserData._id}/profile/${selectedUserData.userData.slug}`"
                      target="_blank"
                    ></vs-button>
                  </vs-tooltip>
                </div>
              </vs-row>
              <vs-divider class="my-base" color="white" />
              <!-- <div v-if="selectedUserData && selectedUserData.userData && selectedUserData.userData.slug">
                <vs-button
                  size="small"
                  style="border: 1px solid #ffffff; border-radius: 6px"
                  icon="icon-external-link"
                  icon-pack="feather"
                  icon-after
                  target
                  :href="`/${selectedUserData.boardData.slug}/${selectedUserData._id}/profile/${selectedUserData.userData.slug}`"
                  >View Full Profile</vs-button
                >
              </div> -->
            </div>
          </div>
        </div>
        <!-- <div v-if="selectedUserData.userData.careerObjective" class="mb-base">
          <h6 class="heading mb-2 text-white">Career Objective</h6>
          <p class="content text-white-o8">{{ selectedUserData.userData.careerObjective }}</p>
        </div> -->
        <div class="my-base" v-if="selectedUserData.userData.about">
          <h6 class="heading mb-2 text-white">About</h6>
          <p class="content text-white-o8">
            {{ selectedUserData.userData.about }}
          </p>
        </div>
      </vs-col>
      <vs-col class="lg:w-1/2 p-base">
        <div v-if="selectedUserData.userData.careerObjective" class="mb-base">
          <h6 class="heading mb-3" style="color: #91919f !important">
            Career Objective
          </h6>
          <p class="content">{{ selectedUserData.userData.careerObjective }}</p>
        </div>
        <hr
          v-if="expertInData && expertInData.length"
          class="my-base text-light"
          style="clear: both; border-top: #f4f6fb"
        />
        <div
          v-if="expertInData && expertInData.length"
          class="my-base items-left expert-in"
        >
          <h6 class="mb-3" style="color: #91919f !important">Expert in</h6>
          <span
            v-for="(skill, index) in expertInData"
            :key="index"
            class="right-panel--item-skill m-1 ml-0"
          >
            {{ skill.title }}
          </span>
        </div>
        <hr
          v-if="
            expertInData &&
            expertInData.length &&
            knownAsData &&
            knownAsData.length
          "
          class="my-base text-light"
          style="clear: both; border-top: #f4f6fb"
        />
        <div
          v-if="knownAsData && knownAsData.length"
          class="my-base items-left known-as"
          style="clear: both"
        >
          <h6 class="mb-3" style="color: #91919f !important">Known for</h6>
          <span
            v-for="(personalityTrait, index) in knownAsData"
            :key="index"
            class="right-panel--item-personality m-1 ml-0"
          >
            {{
              personalityTrait.title ||
              getPersonalityTraitById(personalityTrait.id).title ||
              getPersonalityTraitById(personalityTrait).title
            }}
          </span>
        </div>
        <!-- <hr
          v-if="
            expertInData &&
            expertInData.length &&
            knownAsData &&
            knownAsData.length
          "
          class="my-base text-light"
          style="clear: both; border-top: #f4f6fb"
        />
        <div
          v-if="knownAsData && knownAsData.length"
          class="my-base items-left known-as"
          style="clear: both"
        >
          <h6 class="mb-3" style="color: #91919f !important">Known as</h6>
          <span
            v-for="(personalityTrait, index) in knownAsData"
            :key="index"
            class="right-panel--item-personality m-1 ml-0"
          >
            {{ getPersonalityTraitById(personalityTrait.id).title }}
          </span>
        </div> -->
        <hr
          v-if="
            ((expertInData && expertInData.length) ||
              (knownAsData && knownAsData.length)) &&
            currentlyDevelopingData &&
            currentlyDevelopingData.length
          "
          class="my-base text-light"
          style="clear: both; border-top: #f4f6fb"
        />
        <div
          v-if="currentlyDevelopingData && currentlyDevelopingData.length"
          class="my-base items-left currently-developing"
          style="clear: both"
        >
          <h6 class="mb-3" style="color: #91919f !important">
            Currently developing
          </h6>
          <span
            v-for="(data, index) in currentlyDevelopingData"
            :key="index"
            class="right-panel--item-currently-developing m-1 ml-0"
          >
            {{
              data.title ||
              getPersonalityTraitById(data.id).title ||
              getPersonalityTraitById(data).title
            }}
          </span>
        </div>
        <div
          v-if="
            !(expertInData && expertInData.length) &&
            !(knownAsData && knownAsData.length) &&
            !(currentlyDevelopingData && currentlyDevelopingData.length)
          "
          class="text-light items-center"
        >
          <img
            src="@/assets/images/boards/no-personality-assessment.jpg"
            alt="No personality assessment"
            width="100%"
            height="100%"
            style="opacity: 0.3"
          />
          This user has not completed their Skill and Personality Assessment.
          Once they are done, you shall see the Skills and Personality Traits,
          they are currently working on, here.
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import allLanguages from "@/assets/data/all-languages.js";
import marketplaceList from "@/assets/data/marketplace-list.js";
import constants from "@/constants";
import organizationConfig from "@/assets/data/organization-config.js";

export default {
  props: {
    selectedUserData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      allLanguages,
      marketplaceList,
      constants,
      organizationConfig,
      abilities: [],
      userData: {},
    };
  },
  computed: {
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    locale() {
      return this.$i18n.locale;
    },
    personalityData() {
      const organizationSlug =
        this.$route.params.organizationSlug ||
        this.$route.params.organizationId;
      if (organizationSlug === "gala")
        return this.organizationConfig["gala"].personalityTraits[this.locale];
      else
        return this.organizationConfig["default"].personalityTraits[
          this.locale
        ];
    },
    currentlyDevelopingData() {
      const organizationSlug =
        this.$route.params.organizationSlug ||
        this.$route.params.organizationId;
      let cd = [];
      if (
        this.userData &&
        this.userData.extraCurricular &&
        this.userData.extraCurricular[0] &&
        this.userData.extraCurricular[0].skills &&
        this.userData.extraCurricular[0].skills.length &&
        this.userData.extraCurricular[0].skills.findIndex((skill) => {
          return Boolean(skill.activateLearning) === true;
        }) !== -1
      ) {
        cd = this.userData.extraCurricular[0].skills.filter((skill) => {
          return Boolean(skill.activateLearning) === true;
        });
      }

      if (
        organizationSlug === "gala" &&
        this.abilities &&
        this.abilities.length
      ) {
        cd = [
          ...cd,
          ...this.abilities.filter((p) => {
            return (
              this.priorities &&
              this.priorities[p] !== null &&
              this.priorities[p] !== undefined
            );
          }),
        ];
      } else if (
        this.userData &&
        this.userData.personality &&
        this.userData.personality[0] &&
        this.userData.personality[0].personalityTraits &&
        this.userData.personality[0].personalityTraits.length
      ) {
        cd = [
          ...cd,
          ...this.userData.personality[0].personalityTraits.filter((p) => {
            return p.priorityNumber !== null && p.priorityNumber !== undefined;
          }),
        ];
      }
      //console.log(cd);
      if (cd.length > 0) return cd;
      return null;
    },
    expertInData() {
      if (
        this.userData &&
        this.userData.extraCurricular &&
        this.userData.extraCurricular[0] &&
        this.userData.extraCurricular[0].skills &&
        this.userData.extraCurricular[0].skills.length
      ) {
        return this.userData.extraCurricular[0].skills.filter((skill) => {
          return skill.level === 5;
        });
      }
      return null;
    },
    knownAsData() {
      const organizationSlug =
        this.$route.params.organizationSlug ||
        this.$route.params.organizationId;
      if (this.selectedUserData && organizationSlug === "gala") {
        return this.abilities.slice(0, 6);
      } else if (
        this.userData &&
        this.userData.personality &&
        this.userData.personality[0] &&
        this.userData.personality[0].personalityTraits &&
        this.userData.personality[0].personalityTraits.length
      ) {
        return this.userData.personality[0].personalityTraits.slice(0, 6);
      }
      return null;
    },
  },
  methods: {
    getPersonalityTraitById(id) {
      if (id) {
        // console.log(id);
        const p = this.personalityData.find((pd) => {
          return pd.id === id || pd.personalityMapId - 36 === id;
        });
        // console.log(p);
        return p;
      }
      return {};
    },
    fetchGalaAbilities() {
      const organizationSlug =
        this.$route.params.organizationSlug ||
        this.$route.params.organizationId;
      if (organizationSlug === "gala" && this.userData._id) {
        this.$store
          .dispatch("boards/fetchGalaAbilities", {
            userId: this.selectedUserData.userData._id,
          })
          .then((res) => {
            this.abilities = res.data.abilities;
            this.priorities = res.data.priorities;
          });
      }
    },
    fetchUserDetails() {
      this.$store
        .dispatch("users/fetchUserByEmail", {
          email: this.selectedUserData.userData.email,
        })
        .then((res) => {
          this.userData = res.data[0];
        })
        .catch((err) => {
          throw err;
        });
    },
  },
  created() {
    this.fetchGalaAbilities();
    this.fetchUserDetails();
  },
};
</script>

<style scoped>
.text-white-o8 {
  color: rgba(255, 255, 255, 0.8) !important;
}

.profile-picture {
  border: 5px solid #ffffff !important;
}

.name {
  font-weight: 600;
  font-size: 25px;
  line-height: 41px;
  letter-spacing: -0.02em;
}

.email {
  font-size: 12px;
}

.current-location {
  font-size: 12px;
}

.role-title {
  font-size: 15px;
}

.content {
  font-size: 12px;
  line-height: 23px;
}

.right-panel--item-skill {
  background: rgba(68, 204, 136, 0.1);
  border-radius: 1000px;
  color: #44cc88;
  padding: 1px 12px;
  line-height: 2;
  float: left;
  font-size: 12px;
}

.right-panel--item-personality {
  background: rgba(85, 133, 255, 0.1);
  border-radius: 1000px;
  color: #5585ff;
  padding: 1px 12px;
  line-height: 2;
  float: left;
  font-size: 12px;
}

.right-panel--item-currently-developing {
  background: rgba(242, 146, 0, 0.1);
  border-radius: 1000px;
  color: #f29200;
  padding: 1px 12px;
  line-height: 2;
  float: left;
  font-size: 12px;
}

.known-as:after {
  clear: both;
  height: 0;
  width: 100%;
  content: "";
  display: block;
}

.expert-in:after {
  clear: both;
  height: 0;
  width: 100%;
  content: "";
  display: block;
}

.currently-developing:after {
  clear: both;
  height: 0;
  width: 100%;
  content: "";
  display: block;
}
.con-vs-avatar >>> img {
  object-fit: cover;
}
</style>
